module.exports = __webpack_public_path__ + "assets/img/2019_1.04306254.png";